'use strict';

/**
 * @fileOverview String 扩展类
 * @author ZD @zd.com
 * @version 0.0.1
 */

/**
 * @description 根据索引删除指定个数的字符串
 * @param { Number } i
 */
String.prototype.remove = function (start, num = 1) {
    return this.substring(0, start - num) + this.substring(start, this.length)
}
String.prototype.getBytesLength = function () {
    return this.replace(/[^\u0000-\u00ff]/g, "aa").length;
}
String.prototype.getBytesContent = function () {
    // return this.replace(/<(?!img).*?>/g, "");
    return this.replace(/<.*?>/g, "");
}
String.prototype.transform = function() {
    return this.replace(/\n/g, "\\n").replace(/\r/g, "\\n").replace(/'/g, "\\'").trim()
}
String.limitRowsSize = (content, maxRows, rowSize) => {
    // 先通过换行符分组
    const format = (content || "").split("\n");
    const bateSize = rowSize * 2;
    let result = [];
    let rows = 0;
    format.find(str => {
        const row = Math.ceil(str.getBytesLength() / bateSize);
        const _rows = rows + row;
        if (_rows <= maxRows) {
            result.push(str);
        } else {
            let tatelLength = (maxRows - rows) * bateSize;
            let endLength = 0;
            let end = 0;
            // 找到最后的位置
            // 1. 分组
            str.split("")
            // 返回每个字符的长度
            .map(str => str.getBytesLength())
            // 遍历一直到填满
            .find((length, i) => {
                endLength += length;
                if (endLength === tatelLength) {
                    end = i + 1;
                    return true;
                }
                if (endLength > tatelLength) {
                    end = i;
                    return true;
                }
                return false;
            })
            result.push(str.substring(0, end));
        }
        rows = _rows;
        return rows >= maxRows;
    });
    return result.join("\n");
}